module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/structures/structures-view/structures-view.component.css
// module id = ./src/app/technical/structures/structures-view/structures-view.component.css
// module chunks = main